// Maps alert EVENT_TYPE strings to AnalyticsKind values consumed by AnalyticsChart.
//
// Two layers of keys are included:
//   1. FCCEventType enum values (from src/types/fcc/EventTypes.ts) — the canonical
//      set defined in the codebase.
//   2. Production/fixture strings (HIGH_*, LOW_*, etc.) — the actual strings that
//      appear on real alerts in the wild. These do not match the enum values,
//      so both sets are mapped to ensure the chart renders in practice.
//
// For unmapped event types the value is null, which causes the sidebar to render
// a "no chart available" empty-state instead of crashing.

import type { AnalyticsKind } from '@/composables/useFCCAnalytics'

export const EVENT_TYPE_TO_KIND: Record<string, AnalyticsKind | null> = {
  // FCCEventType enum values
  REFUND_RATE: 'refund-rate',
  CHARGEBACK_RATE: 'chargebacks',
  DECLINE_RATE: 'auth-rate',
  VOLUME_SPIKE: 'volume',
  TRANSACTION_COUNT: 'volume',
  AVERAGE_TRANSACTION: 'volume',

  // Production / fixture strings
  HIGH_REFUND_RATE: 'refund-rate',
  LOW_AUTHORIZATION_RATE: 'auth-rate',
  HIGH_CHARGEBACK_COUNT: 'chargebacks',
  LOW_TRANSACTION_COUNT: 'volume',
  HIGH_VOLUME_OUTLIER: 'volume',
  NEW_MERCHANT_VOLUME: 'volume',
}

export function getAnalyticsKind(eventType: string): AnalyticsKind | null {
  return EVENT_TYPE_TO_KIND[eventType] ?? null
}
